import { z } from 'zod/mini'

import { gtmMetadataShape } from './gtm-metadata'
import { nonEmptyString } from './non-empty-string'

export const pageViewSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('page_view'),
  page_info: z.strictObject({
    // Route name, undefined for unnamed routes
    page_category: z.optional(z.string()),
    // Route meta `tracking.contentGroup`, `'Unmapped'` when not set
    content_group: nonEmptyString(),
  }),
})
